import React, { useState, useEffect, useReducer, useRef } from "react";
import { useSelector } from "react-redux";
import _, { isEmpty } from "lodash";

import Highcharts, { getRendererType } from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { getTheme } from "../common/highChartTheme";

import "../../styles/sps.css";

const ResultChartPrint = (props) => {
  let isLightMode = useSelector((state) => state.theme.lightMode);

  const options = {
    chart: {
      backgroundColor: "transparent",
      type: "line",
    },

    title: {
      text: props.runChartdata.kpiStateName,
      style: {
        color: "black",
      },
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      // gridLineWidth: 1,
      // gridLineInterpolation: "point",
      // tickmarkPlacement: "on",
      gridLineColor: "black",
      lineColor: "black",

      categories: props.runChartdata.chartData.map((x1) => x1.resultDate),
      labels: {
        style: {
          color: "black",
        },
      },
    },
    yAxis: {
      // gridLineWidth: 1,
      gridLineWidth: 1,
      gridLineColor: "black",

      gridLineInterpolation: "point",
      tickmarkPlacement: "on",
      labels: {
        style: {
          color: "black",
        },
      },
      lineColor: "black",
    },
    plotOptions: {
      column: {
        stacking: "normal",
        grouping: false,
        //   borderColor: "black",

        //  pointWidth: calculatePointWidth(250),
        // colorByPoint: true, // Enable per-point colors
        //colors: colorCode, // Set custom bar colors
      },
    },
    legend: {
      // layout: "vertical",
      align: "center",
      verticalAlign: "bottom",
      itemStyle: {
        color: "black",
      },
    },
    series: [
      {
        name: "Actual",
        type: "line",
        legendcolor: "green",
        data: props.runChartdata.chartData.map((x1) => x1.actual),
        color: "green",
      },
      {
        name: "AOP",
        type: "line",
        legendcolor: "blue",
        data: props.runChartdata.chartData.map((x1) => x1.aop),
        color: "blue",
      },
    ],
  };

  return (
    <>
      <span
        style={{
          position: "relative",
          padding: "5px",
          backgroundColor: "white",
          paddingLeft: "40px",
        }}
      >
        <span>
          <span>Baseline:</span>{" "}
          <span style={{ fontWeight: "bold", fontSize: "15px" }}>
            {parseFloat(props.runChartdata.chartData[0].baseline).toFixed(2)}
          </span>{" "}
        </span>
        <span>
          {" "}
          <span>Target: </span>{" "}
          <span style={{ fontWeight: "bold", fontSize: "15px" }}>
            {parseFloat(props.runChartdata.chartData[0].target).toFixed(2)}
          </span>{" "}
        </span>
      </span>
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </>
  );
};
export default ResultChartPrint;